import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * D204 託工入庫單模組權限 hook
 *
 * 基於 pgCode = "pwd204f1"（SYS_Program 中的託工入庫單程式代碼）
 */
export function useD204Permissions() {
  return useModulePermission(Modules.PWD204);
}
